import axios from "axios";
import { supabase } from "../supabaseClient";

// CRM 2.0 bell (M1-F8, design §8.1). The normal Sales App login, no extra permission:
// the server reads the user from the login, so a user only ever gets their own rows.
const base = () => `${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/notifications`;
const auth = () => ({ headers: { Authorization: `Bearer ${supabase.auth.session()?.access_token}` } });
const data = (response) => response.data.data;

// Returns { count }: own unread bell rows of the last 30 days
async function getCrm2UnreadCount() {
  return data(await axios.get(`${base()}/unread-count`, auth()));
}

// Returns { rows, hasMore }, newest first, at most `limit` rows. A row:
// { crm2MessageId, eventKey, title, body, unitLabel, allotmentPaymentId, projectId, created_at, readAt } (times in epoch ms)
// `before` (epoch ms, optional) = the created_at of the last row already shown: the server returns rows made at or
// before it (the caller drops the ones it already has), so reading rows never shifts what "more" brings.
async function getCrm2Notifications({ days = 30, unread = false, before, limit = 20 } = {}) {
  const params = { days, unread, limit };
  if (before) params.before = before;
  return data(await axios.get(base(), { ...auth(), params }));
}

// Returns { ok: true }
async function markCrm2NotificationRead(crm2MessageId) {
  return data(await axios.post(`${base()}/${crm2MessageId}/read`, {}, auth()));
}

// Returns { updated }
async function markAllCrm2NotificationsRead() {
  return data(await axios.post(`${base()}/read-all`, {}, auth()));
}

export { getCrm2UnreadCount, getCrm2Notifications, markCrm2NotificationRead, markAllCrm2NotificationsRead };
